<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->
<p-heading tag="h1" class="text-balance mt-fluid-lg">{{ 'signup.createSpinStep.headline' | translate }}</p-heading>
@if (transactionType$ | async) {
  <div class="w-full">
    <p-text
      [size]="{ base: 'sm', m: 'md' }"
      class="mt-fluid-md text-balance"
      [innerText]="'signup.createSpinStep.subline' | translate"
    ></p-text>
    <p-text
      [size]="{ base: 'sm', m: 'md' }"
      class="mt-fluid-md text-balance"
      [innerText]="'signup.createSpinStep.subline2' | translate"
    ></p-text>
    <form [formGroup]="formGroup" class="mt-fluid-md" data-e2e="confirmation-spin-form">
      <div>
        <p-pin-code
          [label]="'signup.createSpinStep.formLabel.spin' | translate"
          [name]="'SPIN'"
          [length]="spinLength"
          [type]="spinCodeType"
          (change)="submitSpinAndTrack($event)"
          [state]="spinCodeState"
          data-e2e="spin"
          #spinCode
        ></p-pin-code>
      </div>
      <div class="mt-fluid-md">
        <p-pin-code
          [label]="'signup.createSpinStep.formLabel.spinConfirmation' | translate"
          [name]="'REPEAT'"
          [length]="spinLength"
          [type]="spinCodeType"
          (change)="submitSpinRepeatAndTrack($event)"
          [state]="spinCodeRepeatState"
          [message]="spinCodeMessage | translate"
          data-e2e="spin-repeat"
          #spinRepeatCode
        ></p-pin-code>
      </div>
      <p-button
        (click)="submitSpinForm()"
        class="mt-fluid-lg md:mt-fluid-md w-full xs:w-auto"
        variant="primary"
        data-e2e="spin-submit-button"
        [disabled]="disableSubmitButtonAndShowLoading"
        [loading]="disableSubmitButtonAndShowLoading"
        [myprofileSignupUiTrack]="{
          clickElementType: 'button',
          clickElementId: 'call_to_action',
          clickElementName: 'confirm_spin',
          pageName: currentPageName,
          eventAction: 'PAGMyPorsche_SignUpSetsPin_Click',
        }"
      >
        @if (isLastStep(currentStep)) {
          {{ lastStepLabel | translate }}
        }
        @if (!isLastStep(currentStep)) {
          {{ 'signup.createSpinStep.button.label' | translate }}
        }
      </p-button>
    </form>
  </div>
}
